import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { HashStorageService } from '@df/browser/storage/hash-storage.service';
import { App } from '@df/core/app';
import { NICmsContentField } from '@icms/core/content';
import { ICmsPageType } from '@icms/core/content/page/icms-page-type.decorator';
import { PageFooterVisibilityService } from 'projects/app-default/src/app/layout/page/footer/page-footer-visibility.service';
import { PageBuilderhViewComponentDef } from '../common/page-builder-view.component.def';
import { NBuilderProductsSetup } from '../common/products-setup/builder-products-setup.config';
import { OutfitGeneralSetupComponent } from './general-setup/outfit-general-setup.component';
import { NOutfitGeneralSetup } from './general-setup/outfit-general-setup.config';
import { NOutfitBuilder } from './outfit-builder.namespace';
import { OutfitBuilderService } from './outfit-builder.service';
import { OutfitProductsSetupComponent } from './product-setup/outfit-products-setup.component';

@ICmsPageType({
    id: NOutfitBuilder.typeId,
    title: 'Outfit Builder',
    fields: [
        ...NOutfitGeneralSetup.generalSetupFields,
        ...NBuilderProductsSetup.productsSetupFields,
        {
            type: NICmsContentField.EFieldType.label,
            tab: 'Builder Rider Setup',
            key: 'typeData.rider-step-attr',
            title: 'Attribute options used for left section'
        },
        <NICmsContentField.IRepeaterField>{
            tab: 'Builder Rider Setup',
            key: 'typeData.leftSectionRider',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Left section rider',
            itemName: 'Rider option',
            itemNameField: 'listingTitle',
            required: true,
            defaultSize: 1,
            minSize: 1,
            fields: [...NBuilderProductsSetup.leftSectionElementFields, ...NBuilderProductsSetup.focusPositionFields]
        },
        {
            type: NICmsContentField.EFieldType.label,
            tab: 'Builder Horse Setup',
            key: 'typeData.horse-step-attr',
            title: 'Attribute options used for left section'
        },
        <NICmsContentField.IRepeaterField>{
            tab: 'Builder Horse Setup',
            key: 'typeData.leftSectionHorse',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Left section horse',
            itemName: 'Horse option',
            itemNameField: 'listingTitle',
            required: true,
            defaultSize: 1,
            minSize: 1,
            fields: [...NBuilderProductsSetup.leftSectionElementFields, ...NBuilderProductsSetup.focusPositionFields]
        }
    ]
})
@Component({
    selector: 'page-outfit-builder-view',
    templateUrl: 'page-outfit-builder-view.html',
    styleUrls: ['./page-outfit-builder-view.scss'],
    standalone: true,
    imports: [OutfitGeneralSetupComponent, OutfitProductsSetupComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageOutfitBuilderViewComponent extends PageBuilderhViewComponentDef implements OnInit, OnDestroy {
    protected storageData: NOutfitBuilder.IStorageData = { step: -1 }; // -1 to display loading screen before read data from hash
    protected readonly ESteps = NOutfitBuilder.ESteps;

    constructor(
        pageFooterVisibilityService: PageFooterVisibilityService,
        hashStorageService: HashStorageService,
        app: App,
        private outfitBuilderService: OutfitBuilderService
    ) {
        super(pageFooterVisibilityService, hashStorageService, app);
    }

    override async ngOnInit() {
        this.readState();
        if (this.storageData.step < 0) {
            this.storageData = { step: 0 };
        }

        super.ngOnInit();
    }
    protected async loadMainProducts(): Promise<any> {
        const allProducts = await this.outfitBuilderService.loadAllProducts();
        this.isLoaded = !!allProducts?.length;
        if (!allProducts?.length) {
            console.warn('There are no products for outfit builder. Attr `eligible_builder` and correct outfit_builder_section are needed');
        }
        // Load selected products (usually children of products in listiing)
        if (this.storageData.selection) {
            const ids = Object.values(this.storageData.selection)?.map(option => option.matchedProductId)?.filter(id => !!id);
            if (ids?.length) {
                await this.app.resources.product.loadAllIds(ids, 2, { safe: true });
            }
        }
    }
    protected validateData(data: NOutfitBuilder.IStorageData) {
        return this.outfitBuilderService.validateData(data, this.typeData);
    }
}
